import { API_URL, ACTIONS } from "UTILS/Constants";
import BaseAction from "CONFIG/BaseAction";
import { HTTP_METHODS } from "UTILS/Constants";

export class ScheduleSessionAction extends BaseAction {
  constructor() {
    super();
    BaseAction.call(this);
  }
  //never make this function as arrow function
  getInviteDetailsAction(sessionKey) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        requestBody: {
          sessionKey: sessionKey
        },
        url: API_URL.INVITE_DETAILS_USER
      }).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
}
